import { BASE_URL } from "./variables";

export const getPatientAssignedWorkers = async (patientId) => {
  try {
    // Use business login token stored after businessLogin()
    const token = localStorage.getItem('businessAuthToken') || localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(
      `${BASE_URL}/get-patient-assigned-workers?patientId=${patientId}`,
      { headers }
    );

    if (response.status === 404) return { data: [] };
    if (!response.ok) return { data: [] };

    return await response.json();
  } catch (error) {
    console.error('Error fetching assigned workers:', error);
    return { data: [] };
  }
};
